export enum ContentType {
  Events = 'Events',
}
